// One colour: every pixel of the mark to white on dark, to black on light.
.mono {
	filter: brightness(0) invert(1);

	@include light {
		filter: brightness(0);
	}
}
